import { ReactNode } from 'react';
import styled from 'styled-components';
import { ReactComponent as InfoIcon } from '@elementary/common-ui/assets/16x16/info.svg';
import {
  Flex,
  FlexCenter,
  FlexColumn,
  FlexSpace,
  StatusChip,
} from '@elementary/common-ui/components';
import { Divider, IconButton, Tooltip, Typography } from '@mui/material';
import {
  fontSize,
  fontWeight,
  radius,
  space,
} from '@elementary/common-ui/style/utils';
import { ThresholdLevel } from '../../types';
import WidgetSettingsIcon from './WidgetSettingsIcon';

const Wrapper = styled(FlexColumn)`
  width: 100%;
  height: 100%;
  border: 1px solid ${({ theme }) => theme.palette.border.divider};
  border-radius: ${radius('xl', 'xl', 0, 0)};
`;

const TitleWrapper = styled(FlexSpace)`
  align-items: center;
  padding: ${space('sm', 'xxl')};
`;

const Title = styled(Typography)`
  font-size: ${fontSize('lg')};
  font-weight: ${fontWeight('medium')};
  color: ${({ theme }) => theme.palette.content.secondary};
`;

type Props = {
  title: string;
  tooltip: string;
  thresholdLevel: ThresholdLevel;
  children: ReactNode;
  onSettingsClicked: () => void;
};

const Widget = ({
  title,
  tooltip,
  thresholdLevel,
  children,
  onSettingsClicked,
}: Props) => (
  <Wrapper>
    <TitleWrapper>
      <Flex sx={{ alignItems: 'center', gap: 0.5 }}>
        <Title>{title}</Title>
        <Tooltip title={tooltip}>
          <Flex>
            <InfoIcon />
          </Flex>
        </Tooltip>
      </Flex>

      <FlexCenter gap={0.5}>
        {thresholdLevel !== null && <StatusChip status={thresholdLevel} />}

        <IconButton onClick={onSettingsClicked}>
          <WidgetSettingsIcon />
        </IconButton>
      </FlexCenter>
    </TitleWrapper>

    <Divider />

    <FlexColumn sx={{ height: '100%', padding: space(0, 'xs') }}>
      {children}
    </FlexColumn>
  </Wrapper>
);

export default Widget;
